import { render } from "./OrderHistoryEdit.vue?vue&type=template&id=d3b423b8&scoped=true&ts=true"
import script from "./OrderHistoryEdit.vue?vue&type=script&lang=ts"
export * from "./OrderHistoryEdit.vue?vue&type=script&lang=ts"

import "./OrderHistoryEdit.vue?vue&type=style&index=0&id=d3b423b8&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b423b8"]])

export default __exports__